var _defs, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSrmPortalLogoSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 795 795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "srm_portal_app_icon_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.85,737.42a346.37,346.37,0,0,1-63.35,5.91c-190.69,0-345.83-155.14-345.83-345.83A344.2,344.2,0,0,1,133.93,174a27.7,27.7,0,0,1-3.71-3.3A349.17,349.17,0,0,0,46.7,397.5c0,193.43,157.37,350.8,350.8,350.8a351.19,351.19,0,0,0,64.13-6A27.36,27.36,0,0,1,460.85,737.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.38,134.43A344.24,344.24,0,0,1,397.5,51.67c190.69,0,345.83,155.14,345.83,345.83A345.76,345.76,0,0,1,738.09,457a31.27,31.27,0,0,1,4.86,1,351.24,351.24,0,0,0,5.34-60.55c0-193.43-157.36-350.8-350.79-350.8a349.16,349.16,0,0,0-227.42,84A29,29,0,0,1,173.38,134.43Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M721.24,519A347.56,347.56,0,0,1,514.33,723a28.4,28.4,0,0,1,1.75,4.64A352.52,352.52,0,0,0,726,520.49,32.78,32.78,0,0,1,721.24,519Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.64,648.11A390.69,390.69,0,0,1,5,397.5C5,181.06,181.06,5,397.5,5A390.7,390.7,0,0,1,648.89,96.31a38.58,38.58,0,0,1,3.3-3.7A395.65,395.65,0,0,0,397.5,0C178.32,0,0,178.32,0,397.5a395.66,395.66,0,0,0,92,254A37.58,37.58,0,0,1,95.64,648.11Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M704.29,145a38.84,38.84,0,0,1-3.74,3.28A390.73,390.73,0,0,1,790,397.5C790,613.94,613.94,790,397.5,790A390.75,390.75,0,0,1,147.56,700a37.38,37.38,0,0,1-3.32,3.68A395.69,395.69,0,0,0,397.5,795C616.68,795,795,616.68,795,397.5A395.73,395.73,0,0,0,704.29,145Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 733.9,
    cy: 489.09,
    r: 22.54
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 150.83,
    cy: 151.37,
    r: 18.38
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M488.94,716.9a18.38,18.38,0,1,0,18.38,18.37A18.4,18.4,0,0,0,488.94,716.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.56,650a27,27,0,1,0,27.05,27A27.06,27.06,0,0,0,118.56,650Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M678,92a27,27,0,1,0,27,27A27.08,27.08,0,0,0,678,92Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M702.65,397.5c0-168.26-136.89-305.16-305.15-305.16-98.61,0-178.84,80.24-178.84,178.85a178,178,0,0,0,46.82,120.56A186.79,186.79,0,0,1,584.29,523.81c0,73.3-42.45,136.87-104,167.45C608.43,655.09,702.65,537.09,702.65,397.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M397.5,702.66c98.61,0,178.84-80.24,178.84-178.85a178,178,0,0,0-46.82-120.56A186.79,186.79,0,0,1,210.71,271.19c0-73.3,42.44-136.87,104-167.44C186.57,139.91,92.34,257.91,92.34,397.5,92.34,565.76,229.24,702.66,397.5,702.66Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrmPortalLogoSmall);
export default __webpack_public_path__ + "static/media/srm_portal_logo_small.a8d1c2b72afcdc7ed3b99597f68eebb5.svg";
export { ForwardRef as ReactComponent };